import { render } from "./DocumentsManagementPage.vue?vue&type=template&id=37c2676d&scoped=true"
import script from "./DocumentsManagementPage.vue?vue&type=script&lang=js"
export * from "./DocumentsManagementPage.vue?vue&type=script&lang=js"

import "./DocumentsManagementPage.vue?vue&type=style&index=0&id=37c2676d&scoped=true&lang=css"

import exportComponent from "F:\\omar pos 2\\pos_administration_platform\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37c2676d"]])

export default __exports__